// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"63":"36af0c6a","92":"b288a5e3","143":"7be1d1e0","361":"6bcb8f09","642":"67ad013b","649":"9e97ea87","801":"193599a9"}[chunkId] + ".css";
};